import UpcomingTrips from './UpcomingTripsContainer';

export default UpcomingTrips;
